import { render, staticRenderFns } from "./stress-report-form.vue?vue&type=template&id=4680cedf&"
import script from "./stress-report-form.vue?vue&type=script&lang=js&"
export * from "./stress-report-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports